import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init () {
    this.options = {
      muted: true,
      loop: true,
      controls: false,
      soundLevel: 0.5
    }

    this.iframe = this.el.querySelector('iframe')
    this.container = this.el
    this.isInit = false
    this.isPlaying = false
    this.isLoaded = false
    this.isFullscreen = false
    this.isDebugging = false
    this.isMuted = this.options.muted
    this.id = this.el.dataset.id ? this.el.dataset.id.split('?')[0] : null

    if (!this.iframe) {
      console.warn('Missing required arguements, abording Vimeo initializer') // eslint-disable-line
    }

    this.initialize()
  }

  debugger (...log) {
    if (this.isDebugging)
      console.log({
        ...log
      }) //eslint-disable-line
  }

  async initialize () {
    this.debugger(this.id, 'initialize')
    this.playBtns = this.container.querySelectorAll('.js-play')
    this.pauseBtns = this.container.querySelectorAll('.js-pause')
    this.mute = this.container.querySelector('.js-toggle-mute')
    this.area = this.container.querySelector('.c-player__clickable')
    this.progress = this.container.querySelector('.c-player__progress')

    try {
      this.instanciate()
    } catch (error) {
      throw new Error(`Init Custom Player – ${error}`)
    }
  }

  async instanciate () {
    try {
      const { default: Player } = await import(
        /* webpackChunkName: 'vimeo-player' */ '@vimeo/player'
      )

      this.debugger(this.id, 'instantiate - options', this.options)
      this.player = new Player(this.iframe)

      this.isInit = true
      this.isLoaded = true
      this.container.classList.add('is-loaded')

      this.duration = await this.player.getDuration()
      this.setAspectRatio()
      this.on()
      this.setIntersectionObserver()

      this.player.on('playing', () => {
        this.debugger(this.id, 'playing')
        this.isPlaying = true
        this.container.classList.add('is-playing')
        this.trackProgress()
      })

      this.player.on('pause', () => {
        this.isPlaying = false
        this.stopProgress()
        this.container.classList.remove('is-playing')
        // clearTimeout(this.timer)
      })
    } catch (error) {
      throw new Error(`Instanciate Custom Player – ${error}`)
    }
  }

  async setAspectRatio () {
    const promises = [this.player.getVideoWidth(), this.player.getVideoHeight()]
    const [width, height] = await Promise.all(promises)
    this.ratio = width / height
    this.container.style.aspectRatio = this.ratio
  }

  setIntersectionObserver () {
    this.debugger(this.id, 'set autoplay io')
    this.io = new IntersectionObserver(
      entries => {
        entries.forEach(({ isIntersecting }) => {
          if (isIntersecting) {
            if (this.isInit && !this.isPlaying) this.play()
          } else if (this.isPlaying) this.pause()
        })
      },
      { threshold: 0.5 }
    )
    this.io.observe(this.container)
  }

  on () {
    this.debugger(this.id, 'set event listeners')

    this.playHandler = () => {
      this.hasUserInteracted = true
      this.play()
    }
    this.pauseHandler = () => {
      this.hasUserInteracted = true
      this.pause()
    }
    this.togglePlayHandler = () => {
      this.hasUserInteracted = true
      this.togglePlay()
    }

    this.muteHandler = () => this.toggleMute()

    this.progressClickHander = e => {
      const { target } = e
      const bounds = target.getBoundingClientRect()
      const max = bounds.width
      const pos = e.pageX - bounds.left
      const percentage = Math.round((pos / max) * 100)
      this.goTo(percentage)
    }

    this.playBtns.forEach(btn => {
      btn.addEventListener('click', this.playHandler)
    })
    this.pauseBtns.forEach(btn => {
      btn.addEventListener('click', this.pauseHandler)
    })

    this.mute.addEventListener('click', this.muteHandler)
    this.progress.addEventListener('click', this.progressClickHander)
    this.area.addEventListener('click', this.togglePlayHandler)
  }

  off () {
    this.playBtns.forEach(btn => {
      btn.removeEventListener('click', this.playHandler)
    })
    this.pauseBtns.forEach(btn => {
      btn.removeEventListener('click', this.pauseHandler)
    })
    this.toggleMuteBtns.forEach(btn => {
      btn.removeEventListener('click', this.muteHandler)
    })
    this.volume.removeEventListener('mousemove', this.volumeMouseOverHandler)
    this.progress.removeEventListener('click', this.progressClickHandler)
    this.fullscreenBtn.addEventListener('click', this.toggleFullscreenHandler)
  }

  togglePlay () {
    if (this.isPlaying) {
      this.pause()
    } else {
      this.play()
    }
  }

  async play () {
    try {
      this.debugger(this.id, 'play', this.isPlaying)
      if (this.isPlaying === false) {
        this.playbackPromise = this.player.play()
      }
    } catch (error) {
      throw new Error(`Play – ${error}`)
    }
  }

  async pause () {
    try {
      this.debugger(this.id, 'pause function', this.isPlaying)
      if (this.isPlaying === false) return
      this.debugger(this.id, 'pause exectued', this.isPlaying)
      await this.playbackPromise
      this.player.pause()
    } catch (error) {
      throw new Error(`Pause – ${error}`)
    }
  }

  goTo (percentage) {
    try {
      const time = (percentage / 100) * this.duration
      this.player.setCurrentTime(time)
      if (!this.isPlaying) this.updateProgress(time)
    } catch (error) {
      throw new Error(`Goto – ${error}`)
    }
  }

  async destroy () {
    try {
      await this.pause()
      this.off()
      this.seek.innerHTML = '0:00'
      this.progress.style.setProperty('--progress', 0)
      this.stopProgress()
      this.player.destroy()
      this.isInit = false
    } catch (error) {
      throw new Error(`Destroy – ${error}`)
    }
  }

  async toggleMute () {
    this.container.classList.toggle('is-unmute')
    if (this.isMuted) {
      await this.player.setMuted(false)
      this.isMuted = false
    } else {
      await this.player.setVolume(this.options.soundLevel)
      await this.player.setMuted(true)
      this.isMuted = true
    }
  }

  async updateProgress (duration) {
    try {
      duration = Number(duration)
      const progress = duration / this.duration
      this.progress.style.setProperty('--progress', progress)
    } catch (error) {
      throw new Error(`updateProgress – ${error}`)
    }
  }

  async getCurrentTime () {
    try {
      if (this.isInit === false) return
      const time = await this.player.getCurrentTime()
      this.updateProgress(time)
    } catch (error) {
      throw new Error(`getCurrentTime – ${error}`)
    }
  }

  trackProgress () {
    this.interval = setInterval(this.getCurrentTime.bind(this), 100)
  }

  stopProgress () {
    clearInterval(this.interval)
  }
}
